"use strict";

var _regeneratorRuntime = require("/home/runner/work/ami/ami/jaenjs/templates/jaen-template-shopify/node_modules/@babel/runtime/regenerator/index.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Backend = void 0;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

var Backend = /*#__PURE__*/function () {
  function Backend() {
    _classCallCheck(this, Backend);
  }

  _createClass(Backend, [{
    key: "readIndex",
    value: function () {
      var _readIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var indexData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof window === 'undefined')) {
                  _context.next = 2;
                  break;
                }

                throw new Error('window not defined, make sure to load this script in the browser');

              case 2:
                indexData = window.localStorage.getItem(this.indexKey);

                if (!indexData) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", JSON.parse(indexData));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function readIndex() {
        return _readIndex.apply(this, arguments);
      }

      return readIndex;
    }()
  }, {
    key: "writeIndex",
    value: function () {
      var _writeIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(index) {
        var indexData;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!window) {
                  _context2.next = 5;
                  break;
                } // make a file from index including date in name


                indexData = JSON.stringify(index);
                window.localStorage.setItem(this.indexKey, indexData);
                _context2.next = 6;
                break;

              case 5:
                throw new Error('window not defined, make sure to load this script in the browser');

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function writeIndex(_x) {
        return _writeIndex.apply(this, arguments);
      }

      return writeIndex;
    }()
  }, {
    key: "uploadIndex",
    value: function () {
      var _uploadIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var index, indexFile;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.readIndex();

              case 2:
                index = _context3.sent;

                if (!index) {
                  _context3.next = 8;
                  break;
                }

                indexFile = new File([JSON.stringify(index || {})], "".concat(Date.now(), ".json"));
                _context3.next = 7;
                return this.upload(indexFile);

              case 7:
                return _context3.abrupt("return", _context3.sent);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function uploadIndex() {
        return _uploadIndex.apply(this, arguments);
      }

      return uploadIndex;
    }()
  }, {
    key: "downloadIndex",
    value: function () {
      var _downloadIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(url) {
        var indexFile;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return fetch(url);

              case 2:
                _context4.next = 4;
                return _context4.sent.json();

              case 4:
                indexFile = _context4.sent;
                _context4.next = 7;
                return this.writeIndex(indexFile);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function downloadIndex(_x2) {
        return _downloadIndex.apply(this, arguments);
      }

      return downloadIndex;
    }()
  }, {
    key: "resetIndex",
    value: function resetIndex() {
      if (window) {
        window.localStorage.removeItem(this.indexKey);
      } else {
        throw new Error('window not defined, make sure to load this script in the browser');
      }
    }
  }]);

  return Backend;
}();

exports.Backend = Backend;